<template>
  <div class="container-fluid page">

    <div class="row mt-4">
      <div class="col-6">
        <activity-card :activityLogs="activityLogs"></activity-card>
      </div>
      
      <div class="col-6">
        <resources-card :resources="resources"></resources-card>
      </div>
    </div>
    
    <!-- Drop Issues START -->
    <div class="row mt-4 flex-grow-1">
      <div class="col">
        <RetailerLeadDropsWithIssuesCard @updated="updateData()" :drops="dropsWithIssues" :usePagination="true"></RetailerLeadDropsWithIssuesCard>
      </div>
    </div>
    <!-- // Drop Issues END -->

  </div>
</template>

<script>
  // Imports
  import ResourcesCard from '@/components/Cards/ResourcesCard';
  import RetailerLeadDropsWithIssuesCard from '@/components/Cards/RetailerLeadDropsWithIssuesCard';
  import RetailerLeadsService from '../../../services/RetailerLeadsService';
  import DropsService from '../../../services/DropsService';
  import UserStore from '../../../services/UserStore';
  import ActivityCard from '@/components/Cards/ActivityCard';
  //
  export default {
    name: 'retailer-lead-chain-management',

    components: {
      ResourcesCard,
      RetailerLeadDropsWithIssuesCard,
      ActivityCard
    },

    data() {
      return {
        retailerLead: null,
        dropsWithIssues: [],
        pastDrops: [],
        availabilityPeriods: [],
        activityLogs: null,
        resources:[
          { description: 'Support pack', uploadId: 'dashboard_guide-retailer_lead' },
          // {'description': 'Obligations', 'link': 'https://www.fooddrop.co.uk/'},
          { description: 'Terms & conditions', link: 'https://www.fooddrop.co.uk/legal/web-terms-and-conditions' },
          { description: 'Privacy policy', link: 'https://www.fooddrop.co.uk/legal/privacy-policy' },
        ]
      };
    },
    
    created() {
      this.updateData();
    },

    methods:{
     
      updateData() {
        this.fetchRetailerLead();
        this.fetchDropIssues();
        this.fetchRetailerLeadActivity();
      },

      async fetchRetailerLead() {
        try{
          let result = await RetailerLeadsService.getById(UserStore.userData.groupEntityId);
          this.retailerLead = result.data;
        }
        catch(err){
          console.log(err);
        }
      },

      async fetchRetailerLeadActivity() {
        try{
          let activityResult = await RetailerLeadsService.getActivityForId(UserStore.userData.groupEntityId);
          this.activityLogs = activityResult.data;
        }
        catch(err){
          console.log(err);
        }
      },

      async fetchDropIssues() {
        try {
          let result = await DropsService.getMine('issues');
          this.dropsWithIssues = result.data;
        }
        catch(err) {
          console.log(err);
        }
      },

    }
  };
</script>

<style>
  .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }
</style>
